import { render, staticRenderFns } from "./V3MatchHeader.vue?vue&type=template&id=a51e2bf0&scoped=true&"
import script from "./V3MatchHeader.vue?vue&type=script&lang=js&"
export * from "./V3MatchHeader.vue?vue&type=script&lang=js&"
import style0 from "./V3MatchHeader.vue?vue&type=style&index=0&id=a51e2bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51e2bf0",
  null
  
)

export default component.exports